import { Pager } from "@sgm-frontend/core";


export interface UsersResponse extends Pager {
  status: 'success' | 'fail';
  users: UserInfoResponse[];
}

export interface OneUserResponse {
  status: 'success' | 'fail';
  user: UserInfoResponse;
}

export interface UserInfoResponse {
  id: string;
  user_name: string;
  email: string;
  role: string;
  status: boolean;
}

export interface UserInput {
  user_name: string;
  email: string;
  password: string;
  role: string;
  status: boolean;
}

export interface UserRoleInput {
  id: string;
  role: string;
}
